import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";

const IconTrophy = (props: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 14 13" fill="none">
      <path
        d="M3.95833 11.9583H9.29167M6.625 9.29167V11.9583M6.625 9.29167C7.50906 9.29167 8.3569 8.94048 8.98202 8.31536C9.60714 7.69023 9.95833 6.84239 9.95833 5.95833V0.625H3.29167V5.95833C3.29167 6.84239 3.64286 7.69023 4.26798 8.31536C4.8931 8.94048 5.74095 9.29167 6.625 9.29167ZM0.625 3.95833C0.625 4.31196 0.765476 4.65109 1.01552 4.90114C1.26557 5.15119 1.60471 5.29167 1.95833 5.29167C2.31196 5.29167 2.65109 5.15119 2.90114 4.90114C3.15119 4.65109 3.29167 4.31196 3.29167 3.95833C3.29167 3.60471 3.15119 3.26557 2.90114 3.01552C2.65109 2.76548 2.31196 2.625 1.95833 2.625C1.60471 2.625 1.26557 2.76548 1.01552 3.01552C0.765476 3.26557 0.625 3.60471 0.625 3.95833ZM9.95833 3.95833C9.95833 4.31196 10.0988 4.65109 10.3489 4.90114C10.5989 5.15119 10.938 5.29167 11.2917 5.29167C11.6453 5.29167 11.9844 5.15119 12.2345 4.90114C12.4845 4.65109 12.625 4.31196 12.625 3.95833C12.625 3.60471 12.4845 3.26557 12.2345 3.01552C11.9844 2.76548 11.6453 2.625 11.2917 2.625C10.938 2.625 10.5989 2.76548 10.3489 3.01552C10.0988 3.26557 9.95833 3.60471 9.95833 3.95833Z"
        stroke={props.color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconTrophy;
